import React from "react";

const PlanSelectItem = ({ selected = false, selectedPlanIdx, idx, label1, label2, label3,
                            doNotRenew = false, readOnly = false, value,
                            onClick, extraCssClasses }) => {
    const onItemClick = () => {
        if (onClick && !readOnly) {
            onClick();
        }
    };

    const getCssClass = () => {
        let css = '';
        if (readOnly) {
            css += `read-only `;
        }

        if (selected || (selectedPlanIdx !== null && parseInt(selectedPlanIdx) === idx)) {
            css += `selected`;
        } else if (selectedPlanIdx !== null) {
            css += `unselected`;
        }

        if (extraCssClasses)
            css += extraCssClasses;
        return css;
    }

    return (
        <div className={`vri-plan-card flexColumn ${getCssClass()}`}
             data-testid={'planSelectItem'}
             data-selected-plan-idx={selectedPlanIdx}
             data-idx={idx}
             data-level-value={value}
             data-selected={selected}
             data-readonly={readOnly}
             onClick={onItemClick}>
            <div className={'plan-sub-title'}>{label1}</div>
            <div className={'plan-sub-details'}>{label2}</div>
            {
                label3 && (
                    <div className={'plan-sub-details'}>{label3}</div>
                )
            }

            {
                doNotRenew && (
                    <div className={'plan-sub-details'}>{i18n.payments.setNotToRenew}</div>
                )
            }

        </div>
    );
};

export default PlanSelectItem;